module.exports = __webpack_public_path__ + "assets/media/external.a7c60cef.mp3";